module.exports = __webpack_public_path__ + "static/media/balance_10000000.65e7522d.png";